import Column from 'components/column';
import Section from 'components/section';
import React from 'react';

import * as styles from './service-grid.module.scss';
import { graphql } from 'gatsby';
import Image from 'components/image';
import MatrixFigure from 'components/matrix-figure';
import Link, { LinkType } from 'components/link';

const ServiceGridItem: React.FC<GatsbyTypes.DatoCmsServiceGridItem> = ({ link = [], ...props }) => {
  const serviceLink = link.length > 0 ? link[0] : null;
  const GridItemImg = () => (
    <div className={styles.image}>
      {props.showFigure && <MatrixFigure className={styles.imageFigure} size={'small'} />}
      <Image {...props.image} />
    </div>
  );

  return (
    <Column className={styles.sectionGridItem} xl={6} lg={6} md={6}>
      <div>
        <GridItemImg />
        {serviceLink && (
          <div className={styles.linkWrapper}>
            <Link arrow={'rightMedium'} className={styles.link} link={serviceLink.link as LinkType}>
              {serviceLink.text}
            </Link>
          </div>
        )}
        <div className={styles.text} dangerouslySetInnerHTML={{ __html: props.text as string }} />
      </div>
    </Column>
  );
};

const ServiceGrid: React.FC<GatsbyTypes.DatoCmsServiceGrid> = ({
  serviceGridItems = [],
  ...props
}) => {
  return (
    <Section sectionClass={styles.section} {...props} topBackgroundOffset>
      <Column className={styles.itemGrid}>
        <Column innerGap xl={{ width: 10, offset: 1 }}>
          {serviceGridItems
            .filter((item): item is GatsbyTypes.DatoCmsServiceGridItem => !!item)
            .map((item) => (
              <ServiceGridItem key={item.id} {...item} />
            ))}
        </Column>
      </Column>
    </Section>
  );
};

export default ServiceGrid;

export const query = graphql`
  fragment ServiceGrid on DatoCmsServiceGrid {
    __typename
    id: originalId
    serviceGridItems {
      id: originalId
      title
      text
      image {
        isImage
        mimeType
        gatsbyImageData(placeholder: DOMINANT_COLOR, imgixParams: { ar: "1.6", fit: "crop" })
        alt
        url
      }
      showFigure
      link {
        text
        externalUrl
        link {
          ...LinkCollection
        }
      }
    }
    backgroundColor
    topBackgroundColor
  }
`;
